import React from "react";
import { useLocation } from "react-router-dom";

const InviteProgress = ({
                            percentage,
                            text,
                            width,
                            height,
                            borderRadius,
                            textColor,
                            fontSize,
                            backgroundColor,
                            progressColor,
                        }) => {

    let location = useLocation();
    console.log("percentage:", percentage);
    return (
        <div style={{ width, height, borderRadius, backgroundColor, overflow: "hidden" }}>
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
        <span
            style={{
                fontSize,
                fontWeight:700,
                color: textColor,
            }}
        >
          {text}
        </span>
            </div>
            <div style={{ backgroundColor: progressColor, marginTop: `-${height}`, height, width: `${percentage}%` }} />
        </div>
    );
};

export default InviteProgress;
